export default "__VITE_ASSET__DLcKwF7g__"